import { createBrowserRouter } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import { ROUTES } from "./utils/navigation";
import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import WhyTrackmate from "./pages/WhyTrackmate";
import Features from "./pages/Features";
import FeatureDetails from "./pages/FeatureDetails";
import Resources from "./pages/Resources";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import FAQ from "./pages/FAQ";
import SubscriptionPlans from "./pages/SubscriptionPlans";
import CompareDevices from "./pages/CompareDevices";
import FleetInquiry from "./pages/FleetInquiry";
import BecomeDealer from "./pages/BecomeDealer";
import InstallationGuide from "./pages/InstallationGuide";
import APIintegration from "./pages/APIintegration";
import Troubleshooting from "./pages/Troubleshooting";
import HelpCenter from "./pages/HelpCenter";
import ArticleDetails from "./pages/ArticleDetails";
import GetTrackmate from "./pages/GetTrackmate";
import ProductDetails from "./pages/ProductDetails";
import NotFound from "./pages/NotFound";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import FleetFormPage from "./pages/FleetFormPage";
import CartPage from "./pages/CartPage";
import Industries from "./pages/Industries";
import FindDealers from "./pages/FindDealers/FindDealers";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      Component: MainLayout,
      children: [
        {
          index: true,
          path: ROUTES.home,
          Component: Home,
        },
        {
          path: ROUTES.solutions,
          Component: Solutions,
        },
        {
          path: ROUTES.industries,
          Component: Industries,
        },
        {
          path: ROUTES.industryDetails,
          Component: Industries,
        },
        {
          path: ROUTES.whyTrackmate,
          Component: WhyTrackmate,
        },
        {
          path: ROUTES.features,
          Component: Features,
        },
        {
          path: ROUTES.featureDetail,
          Component: FeatureDetails,
        },

        {
          path: ROUTES.resources,
          Component: Resources,
        },
        {
          path: ROUTES.aboutUs,
          Component: AboutUs,
        },
        {
          path: ROUTES.contactUs,
          Component: ContactUs,
        },
        {
          path: ROUTES.faq,
          Component: FAQ,
        },

        {
          path: ROUTES.subscriptionPlans,
          Component: SubscriptionPlans,
        },
        {
          path: ROUTES.compareDevices,
          Component: CompareDevices,
        },

        {
          path: ROUTES.fleetInquiry,
          Component: FleetInquiry,
        },
        {
          path: ROUTES.becomeDealer,
          Component: BecomeDealer,
        },
        {
          path: ROUTES.installationGuide,
          Component: InstallationGuide,
        },
        {
          path: ROUTES.APIintegration,
          Component: APIintegration,
        },
        {
          path: ROUTES.helpCenter,
          Component: HelpCenter,
        },
        {
          path: ROUTES.troubleshooting,
          Component: Troubleshooting,
        },
        {
          path: ROUTES.articleDetails,
          Component: ArticleDetails,
        },
        {
          path: ROUTES.getTrackmate,
          Component: GetTrackmate,
        },

        {
          path: ROUTES.product,
          Component: ProductDetails,
        },

        {
          path: ROUTES.cart,
          Component: CartPage,
        },

        {
          path: ROUTES.findDealer,
          Component: FindDealers,
        },

        // 404 route
        {
          path: "*",
          Component: NotFound,
        },
      ],
    },
    {
      path: ROUTES.fleetInquiryForm,
      Component: FleetFormPage,
    },
    {
      path: ROUTES.checkout,
      Component: Checkout,
    },
    {
      path: ROUTES.login,
      Component: Login,
    },
  ],
  {
    basename: "/shop",
  }
);
